Service = App.loadClass 'core::Angular/Service'

class exports.PreferencesService extends Service
    constructor: (@http) ->
        return

    getUserPreferences: () =>
        @http.post 'backend/admin/preferences/get-user-preferences'

    saveUserPreferences: (preferences) =>
        return @http.post 'backend/admin/preferences/save-user-preferences',
            preferences: preferences

    sendTestMessage: (username, preference) =>
        @http.post 'bot/chat/send-test-message',
            username: username
            event: preference
